import ThemeProvider, { CarvanaTheme } from './ThemeProvider/ThemeProvider';
import Font from './Font';
import GlobalStyle from './GlobalStyle';
import Reset, { HeaderReset } from './Reset';
import {
  cvGray,
  cvRed,
  cvWhite,
  cvBlue,
  cvYellow,
  cvGreen,
  cvStroke,
  cvBody,
  cvImpersonationRed,
  cvFontFamily,
  cvFontSize,
  cvBreakpoint0,
  cvBreakpoint768,
  cvBreakpoint1024,
  cvBreakpoint1280,
  cvBreakpoint1920,
  cvTypography
} from './ThemeUtilities/ThemeUtilities';

export default ThemeProvider;
export {
  CarvanaTheme,
  ThemeProvider,
  Font,
  Reset,
  HeaderReset,
  GlobalStyle as createGlobalStyle,
  cvGray,
  cvRed,
  cvWhite,
  cvBlue,
  cvYellow,
  cvGreen,
  cvStroke,
  cvBody,
  cvImpersonationRed,
  cvFontFamily,
  cvFontSize,
  cvBreakpoint0,
  cvBreakpoint768,
  cvBreakpoint1024,
  cvBreakpoint1280,
  cvBreakpoint1920,
  cvTypography
};
